const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://hashimhz.github.io/Protfolio/',
  title: 'HZ.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Hashim Alzubi',
  role: 'Computer Programmer',
  description:
    'I’m a Computer Programmer with hands-on experience in Java, JavaScript, WordPress, and full-stack web development. I’ve built end-to-end projects using Servlets, JSP, and MySQL, and shipped a live WordPress site for an organization with dynamic event features and admin-only tools. I’m passionate about building clean, user-focused applications and continuously expanding my skills across both frontend and backend development.',
  resume: `${process.env.PUBLIC_URL}/HashimAlzubi_Resume.pdf`,
  social: {
    linkedin: '',
    github: 'https://github.com/hashimhz',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'The New Root = WordPress Website',
    description:
      'A fully customized WordPress business website built from scratch. Designed and implemented the About page, service sections, responsive layouts, custom illustrations, and integrated advanced search functionality using Relevanssi plugin. Focused on clean UI/UX, structured content, and speed optimization.',
    stack: ['WordPress', 'Elementor', 'PHP', 'CSS', 'Relevanssi Plugin', 'Responsive Design'],
    sourceCode: '',
    livePreview: 'https://thenewroot.com',
  },
  {
    name: 'Flutter To-Do Web',
    description:
      'A lightweight and intuitive task management web app built with Flutter. Users can quickly add tasks via a top input bar and manage them in a numbered list. Tasks can be deleted through a long-press action with confirmation, offering a simple yet effective way to organize daily to-dos directly in the browser.',
    stack: ['Flutter (Web)', 'Dart', 'Material Design'],
    sourceCode: '',
    livePreview: '',
  },
  {
    name: 'Car Dealership Desktop App (Flutter)',
    description:
      'AutoManager is a desktop-based Flutter application designed to manage the operations of a car dealership through a clean, button-driven interface. Built with Dart and powered by a local SQLite database using sqflite_common_ffi, the app features dedicated sections for managing customers, vehicles, dealerships, and sales. Each section supports full CRUD functionality, enabling users to view, add, update, and delete records with ease. With intuitive navigation, form-based input, and persistent local storage, AutoManager showcases efficient Flutter development and structured application design tailored for real-world business use cases.',
    stack: ['Flutter', 'Dart', 'sqflite_common_ffi (SQLite)', 'Material Design', 'Desktop (Windows/Linux/MacOS) Runtime'],
    sourceCode: '',
    livePreview: '',
  },
  {
    name: 'Crude Run Weekly Data Manager',
    description:
      'A terminal-based Python 3 application that manages and analyzes weekly crude oil processing statistics. The program connects to a structured database and offers an interactive, menu-driven interface for displaying, searching, adding, updating, and sorting records. Built using the Model-View-Controller (MVC) architecture to separate concerns between presentation, business logic, and data access, this project demonstrates practical CRUD operations, modular code organization, and database integration.',
    stack: ['Python 3', 'MySQL', 'VS Code', 'Modular Architecture (MVC-like)', 'Terminal-based UI'],
    sourceCode: '',
    livePreview: '',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Java',
  'Python',
  'HTML',
  'CSS',
  'JavaScript',
  'PHP',
  'Dart',
  'WordPress',
  'MySQL',
  'JSP',
  'Linux',
  'Git',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'hashimzh@gmail.com',
}


export { header, about, projects, skills, contact }
